import { Checkbox } from "@mui/material";

const CustomCheckbox = ({ isChecked, handleCheckboxChange, checkboxId, disabled, label=null }) => {

    return(
        <div
            className={`d-flex cm-pointer ${
                disabled
                ? "cm-pointer-none"
                : "cm-pointer"
            }`}
        >
            <Checkbox
                id={checkboxId}
                checked={isChecked}
                inputProps={{ "aria-label": "controlled" }}
                disableRipple={true}
                className={`cm-checkbox-input my-auto ${disabled ? "opacity-50" : ""}`}
                disabled={disabled}
                onChange={handleCheckboxChange}
            />
            {label && <label
                htmlFor={checkboxId}
                className={`my-auto ms-12 cm-sm-txt fw-medium cm-pointer ${
                disabled
                    ? "text-blue-gray-500"
                    : "cm-pointer"
                }`}
            >
                {label}
            </label>}
        </div>
    )

}

export default CustomCheckbox;